import React from "react";
import { FcGoogle } from "react-icons/fc";

const GoogleAuthSignInButton = () => {
  const googleSignIn = () => {
    window.open("https://ferias-ingenio-backend.vercel.app/api/auth/google", "_self");
    // window.open("http://localhost:5000/api/auth/google", "_self");
  };

  return (
    <div className="google-signin-button" onClick={googleSignIn}>
      <div className="icon-button">
        <FcGoogle />
      </div>
      Iniciar Sesión Google
    </div>
  );
};

export default GoogleAuthSignInButton;
